import React, { FunctionComponent, useCallback } from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { SvgImage } from '../../../../shared/components';
import { PngImage } from '../../../../shared/components/png-image';
import { selectNewNativeAppBannerEnabled } from '../../../../shared/features/flags/selectors';
import { isPDDUserSelector } from '../../../../shared/features/user/selectors';
import { STORE_URL_UNIVERSAL } from '../../../../shared/helpers/constants';
import { i18n } from '../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../shared/helpers/metrika';
import styles from './styles.css';

interface TouchNativeAppBannerProps {
    fourButtonsLayout?: boolean;
}

export const TouchNativeAppBanner: FunctionComponent<TouchNativeAppBannerProps> = ({ fourButtonsLayout }) => {
    const isNewNativeAppBannerEnabled = useSelector(selectNewNativeAppBannerEnabled);
    const onDownloadNativeAppClick = useCallback(() => {
        countMetrika('main_screen', 'download_telemost_promo_click');
        window.location.href = STORE_URL_UNIVERSAL;
    }, []);
    const isPdd = useSelector(isPDDUserSelector);
    if (!isNewNativeAppBannerEnabled || isPdd) {
        return <></>;
    }
    return (
        <ScopedTheme theme="light">
            <div className={cn(styles.touchNativeAppBanner, { [styles.fourButtonsLayout]: fourButtonsLayout })}>
                <div className={styles.left}>
                    <Text as="div" className={styles.title} typography="heading-xs">
                        {i18n('native-app-banner', 'title')}
                    </Text>
                    <Text as="div" className={styles.description} typography="caption-md-regular" color="tertiary">
                        {i18n('native-app-banner', 'description')}
                    </Text>
                    <Button onClick={onDownloadNativeAppClick} view="brand" className="download-native-app-button">
                        {i18n('native-app-banner', 'download-telemost')}
                    </Button>
                </div>
                <div className={styles.right}>
                    <SvgImage className={styles.spot} imageName="nativeAppBannerSpot" />
                    <PngImage className={styles.phone} name="nativeAppBannerPhone" />
                </div>
            </div>
        </ScopedTheme>
    );
};
